import { v4 as uuidv4 } from 'uuid';
import { colorUtil } from "../../util/ColorUtil";

export const HeartIcon = (props: {
  width: string;
  height: string;
  isSelected?: boolean;
  color?: string;
}) => {
  const filterId = uuidv4();
  const {
    isSelected = false,
    width,
    height,
    color = colorUtil.heartIcon,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={`url(#${filterId})`}>
        {isSelected ? (
          <path
            d="M25.95 38.3701L8.38 20.8001C3.87 16.2901 3.87 8.98006 8.38 4.47006C12.89 -0.0399415 20.2 -0.0399415 24.71 4.47006L25.96 5.72006L27.3 4.38006C31.81 -0.129941 39.12 -0.129941 43.63 4.38006C48.14 8.89006 48.14 16.2001 43.63 20.7101L25.97 38.3701H25.95Z"
            fill={colorUtil.heartIcon}
          />
        ) : (
          <path
            d="M9.44 18.74C5.52 14.82 5.52 8.45 9.44 4.53C11.34 2.63 13.86 1.59 16.54 1.59C19.22 1.59 21.75 2.63 23.64 4.53L25.95 6.84L28.35 4.44C30.25 2.54 32.77 1.5 35.45 1.5C38.13 1.5 40.66 2.54 42.55 4.44C44.44 6.34 45.49 8.86 45.49 11.54C45.49 14.22 44.45 16.75 42.55 18.64L25.95 35.24L9.44 18.74Z"
            fill={colorUtil.white}
          />
        )}

        <path
          d="M35.46 3C37.74 3 39.89 3.89 41.5 5.5C43.11 7.11 44 9.26 44 11.54C44 13.82 43.11 15.97 41.5 17.58L25.96 33.12L10.51 17.67C7.18 14.34 7.18 8.92 10.51 5.59C12.12 3.98 14.27 3.09 16.55 3.09C18.83 3.09 20.98 3.98 22.59 5.59L23.84 6.84L25.96 8.96L28.08 6.84L29.42 5.5C31.03 3.89 33.18 3 35.46 3ZM35.46 0C32.51 0 29.55 1.13 27.3 3.38L25.96 4.72L24.71 3.47C22.45 1.22 19.5 0.09 16.54 0.09C13.58 0.09 10.64 1.22 8.38 3.47C3.87 7.98 3.87 15.29 8.38 19.8L25.95 37.37L43.61 19.71C48.12 15.2 48.12 7.89 43.61 3.38C41.36 1.13 38.4 0 35.45 0L35.46 0Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="0.997498"
          y="0"
          width="49.995"
          height="45.37"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_503"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3_503"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
